"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CountryCode = void 0;
var CountryCode;
(function (CountryCode) {
    CountryCode["US"] = "US";
    CountryCode["IN"] = "IN";
    CountryCode["UNKNOWN"] = "UNKNOWN";
})(CountryCode || (exports.CountryCode = CountryCode = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ291bnRyeUNvZGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29uc3RhbnRzL0NvdW50cnlDb2RlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLElBQVksV0FJWDtBQUpELFdBQVksV0FBVztJQUNuQix3QkFBUyxDQUFBO0lBQ1Qsd0JBQVMsQ0FBQTtJQUNULGtDQUFtQixDQUFBO0FBQ3ZCLENBQUMsRUFKVyxXQUFXLDJCQUFYLFdBQVcsUUFJdEIiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZW51bSBDb3VudHJ5Q29kZSB7XG4gICAgVVMgPSBcIlVTXCIsXG4gICAgSU4gPSBcIklOXCIsXG4gICAgVU5LTk9XTiA9IFwiVU5LTk9XTlwiXG59Il19